export function updateAccountSuccess(state, data) {
  return {
    ...state,
    account: {
      ...state.account,
      ...data,
    },
  };
}

export function updatePublisherCompanyInfoSuccess(state, data) {
  return {
    ...state,
    account: {
      ...state.account,
      ...data,
    },
  };
}

export function updatePaymentInfoSuccess(state, data) {
  return {
    ...state,
    account: {
      ...state.account,
      ...data,
    },
  };
}

export function changeActiveTab(state, tabName) {
  return {
    ...state,
    account: {
      ...state.account,
      activeInfoTab: tabName,
    },
  };
}



/** WEBPACK FOOTER **
 ** ./js/core/profile.js
 **/